import FilterIcon from './component'

export default FilterIcon
